module.exports = __webpack_public_path__ + "static/scale-model-of-secaucus-mural-in-newark-new-jersey-99954c43ce14c08f1f76f5ff65ac62e0.png";